import { Routes, Route, Navigate } from "react-router-dom";
import PublicRoute from "./wrapped/PublicRoute";
import ProtectedRoute from "./wrapped/ProtectedRoute";
import MainLayout from "../layouts/MainLayout";
import routes from "../../system/routes";
import Login from "../pages/Login";
import CreatePassword from "../pages/CreatePassword";
import CompanySignup from "../pages/CompanySignup";
import ForgotPassword from "../pages/ForgotPassword";

const App = () => {
  return (
    <Routes>
      {/* Public route */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />

      <Route
        path="/register-company"
        element={
          <PublicRoute>
            <CompanySignup />
          </PublicRoute>
        }
      />

      <Route
        path="/setup-password"
        element={
          <PublicRoute>
            <CreatePassword />
          </PublicRoute>
        }
      />

      {/* Private routes with layout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        {routes.PrivateRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={<route.component />} />
        ))}
      </Route>

      {/* Catch-all redirect */}
      {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
    </Routes>
  );
};

export default App;
